module.exports = __webpack_public_path__ + "static/media/Gaurish.0be4cdcf.jpg";